// extracted by mini-css-extract-plugin
export default {"story":"StoryList_story__rXK3M"};